import { API_ENDPOINTS, withParams } from '../config/apis';
import { apiRequest } from '../api/client';

/** 기기(리더기) 코드 — 백엔드 ReaderDeviceResponse */
export type ReaderDevice = {
  id: number;
  code: string;
};

export const readerDeviceService = {
  list: () =>
    apiRequest<{ readerDevices: ReaderDevice[] }>(API_ENDPOINTS.readerDeviceList)
      .then((res) => res.readerDevices),

  create: (code: string) =>
    apiRequest<ReaderDevice>(API_ENDPOINTS.readerDeviceCreate, { body: { code } }),

  update: (readerDeviceId: number, code: string) =>
    apiRequest<ReaderDevice>(
      withParams(API_ENDPOINTS.readerDeviceUpdate, { readerDeviceId }),
      { body: { code } }
    ),

  delete: (readerDeviceId: number) =>
    apiRequest<void>(withParams(API_ENDPOINTS.readerDeviceDelete, { readerDeviceId })),
};
